import { DestinationEnum } from './enums';
/**
 * All the destinations, i.e: ["HUMIO", "ADOBE" "DATAVAREHUS"]
 * @category Constants
 */
export var DEFAULT_DESTINATIONS = [
    DestinationEnum.Adobe,
    DestinationEnum.Humio,
    DestinationEnum.Datavarehus,
];
/**
 * Cookie value to be set if retrieving cookie has gone wrong. Prevents further requests to API for a short timespan.
 * @category Constants
 */
export var PREVENTION_COOKIE_VALUE = 'declaredid|ikke_satt|X';
//# sourceMappingURL=constants.js.map